// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

// export const handleDownloadExcel = async (
//   tenderInfo,
//   postulaciones,
//   preguntas
// ) => {
//   if (!tenderInfo || !postulaciones || postulaciones.length === 0) {
//     toast.error("No hay información disponible para exportar.");
//     return;
//   }

//   // ✅ Crear un nuevo libro de Excel
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Licitación y Postulaciones");

//   // 🎨 **Estilos para encabezados**
//   const headerStyle = {
//     font: { bold: true, color: { argb: "FFFFFF" }, name: "Arial", size: 11 },
//     fill: { type: "pattern", pattern: "solid", fgColor: { argb: "4F81BD" } },
//     alignment: { horizontal: "center", vertical: "middle" },
//   };

//   // 🎨 **Estilos para celdas normales**
//   const cellStyle = {
//     alignment: { horizontal: "center", vertical: "middle" },
//     font: { name: "Arial", size: 11 },
//   };

//   // ✅ Agregar detalles de la licitación
//   const details = [
//     ["Detalles de la Licitación"],
//     ["Título", tenderInfo.tender.titulo],
//     ["Nº de Licitación", tenderInfo.tender.id_tender],
//     ["Categoría", tenderInfo.tender.categoria],
//     ["Empresa", tenderInfo.tender.company_name || "No especificado"],
//     [
//       "Creador",
//       `${tenderInfo.tender.user_name} ${tenderInfo.tender.user_lastname}`,
//     ],
//     [
//       "Ciudades",
//       (() => {
//         try {
//           const ciudades = JSON.parse(tenderInfo.tender.ciudad);
//           return Array.isArray(ciudades)
//             ? ciudades.join(", ")
//             : "No especificado";
//         } catch (e) {
//           return "No especificado";
//         }
//       })(),
//     ],
//     ["Última Actualización", tenderInfo.tender.created_at],
//     ["Fecha Máx de Postulación", tenderInfo.tender.fecha_maxima_postulacion],
//   ];

//   details.forEach((row) => {
//     const rowRef = worksheet.addRow(row);

//     // **Columna A (Encabezados)**
//     rowRef.getCell(1).fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "4F81BD" }, // Azul claro solo para A
//     };
//     rowRef.getCell(1).font = {
//       bold: true,
//       name: "Arial",
//       size: 11,
//       color: { argb: "FFFFFF" },
//     };
//     rowRef.getCell(1).alignment = {
//       horizontal: "center",
//       vertical: "middle",
//     };

//     // **Columna B (Valores)**
//     rowRef.getCell(2).alignment = { horizontal: "center", vertical: "middle" }; // Alineación izquierda
//     rowRef.getCell(2).font = { name: "Arial", size: 11 };

//     // Aplica bordes a ambas columnas
//     rowRef.eachCell((cell) => {
//       cell.border = {
//         top: { style: "thin" },
//         left: { style: "thin" },
//         bottom: { style: "thin" },
//         right: { style: "thin" },
//       };
//     });
//   });

//   // ✅ Agregar una fila vacía sin formato después de los detalles
//   worksheet.addRow([]);

//   const headers = [
//     "Postulación ID",
//     ...postulaciones.map((p) => p.id_application),
//   ];

//   // ⬇️ Ahora definimos correctamente `headerRow` antes de aplicarle estilos
//   const headerRow = worksheet.addRow(headers);

//   // Aplicar estilos a los encabezados
//   headerRow.eachCell((cell) => {
//     cell.style = headerStyle; // Aplica el estilo predefinido
//     cell.border = {
//       top: { style: "thin" },
//       left: { style: "thin" },
//       bottom: { style: "thin" },
//       right: { style: "thin" },
//     };
//   });

//   // ✅ Agregar datos de postulantes
//   const dataRows = [
//     [
//       "Nombre postulante",
//       ...postulaciones.map(
//         (p) => `${p.user_postulante.nombre} ${p.user_postulante.apellido}`
//       ),
//     ],
//     [
//       "Correo postulante",
//       ...postulaciones.map((p) => p.user_postulante.correo),
//     ],
//     [
//       "Celular postulante",
//       ...postulaciones.map(
//         (p) => `+${p.user_postulante.codigo_pais} ${p.user_postulante.celular}`
//       ),
//     ],
//     [
//       "Propuesta de los postulantes",
//       ...postulaciones.map((p) => p.detalles_oferta || "No especificado"),
//     ],
//     [
//       "Documentos Adjuntos",
//       ...postulaciones.map((p) =>
//         p.archivos_adjuntos && p.archivos_adjuntos.length > 0
//           ? p.archivos_adjuntos.map((a) => a.file_name).join(", ")
//           : "Sin documentos"
//       ),
//     ],
//   ];

//   dataRows.forEach((row) => {
//     const dataRow = worksheet.addRow(row);
//     dataRow.eachCell((cell) => {
//       cell.style = cellStyle;
//       cell.border = {
//         top: { style: "thin" },
//         left: { style: "thin" },
//         bottom: { style: "thin" },
//         right: { style: "thin" },
//       };
//     });
//   });
//   // ✅ Agregar una fila vacía antes de la nueva tabla
//   worksheet.addRow([]);

//   // ✅ Encabezado de la tabla de preguntas
//   const preguntasHeader = [
//     "Preguntas",
//     ...postulaciones.map((p) => p.id_application),
//   ];
//   const preguntasHeaderRow = worksheet.addRow(preguntasHeader);

//   // Aplicar estilos a los encabezados
//   preguntasHeaderRow.eachCell((cell) => {
//     cell.style = headerStyle; // Aplica el estilo predefinido
//     cell.border = {
//       top: { style: "thin" },
//       left: { style: "thin" },
//       bottom: { style: "thin" },
//       right: { style: "thin" },
//     };
//   });

//   // ✅ Agregar preguntas y respuestas en formato de tabla
//   preguntas.forEach((pregunta) => {
//     const questionRow = worksheet.addRow([
//       pregunta.question,
//       ...postulaciones.map((p) => {
//         const respuesta = p.respuestas_preguntas_licitador[pregunta.question];
//         if (respuesta && typeof respuesta === "object" && respuesta.file_name) {
//           return respuesta.file_name; // Solo muestra el nombre
//         }
//         return respuesta || "No respondida";
//       }),
//     ]);

//     questionRow.eachCell((cell) => {
//       cell.style = cellStyle;
//       cell.border = {
//         top: { style: "thin" },
//         left: { style: "thin" },
//         bottom: { style: "thin" },
//         right: { style: "thin" },
//       };
//     });
//   });

//   // ✅ Ajustar ancho de columnas automáticamente
//   worksheet.columns.forEach((column) => {
//     let maxLength = 0;
//     column.eachCell({ includeEmpty: true }, (cell) => {
//       const text = cell.value ? cell.value.toString() : "";
//       maxLength = Math.max(maxLength, text.length);
//     });
//     column.width = maxLength + 5;
//   });

//   worksheet.views = [{ showGridLines: false }];

//   // ✅ Agregar una fila vacía antes del pie de página
//   worksheet.addRow([]);

//   // ✅ Agregar pie de página con branding
//   const footerRow = worksheet.addRow(["Creado por Procu"]);
//   footerRow.getCell(1).font = {
//     italic: true,
//     color: { argb: "808080" },
//     size: 10,
//   }; // Texto en gris y cursiva
//   footerRow.getCell(1).alignment = { horizontal: "center" };

//   // ✅ Fusionar celdas para centrar el texto
//   worksheet.mergeCells(`A${footerRow.number}:B${footerRow.number}`);

//   // ✅ Generar archivo y descargar
//   const buffer = await workbook.xlsx.writeBuffer();
//   saveAs(
//     new Blob([buffer]),
//     `Licitacion_${tenderInfo.tender.id_tender}_${tenderInfo.tender.titulo}.xlsx`
//   );
// };

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { toast } from "sonner";

export const handleDownloadExcel = async (
  tenderInfo,
  postulaciones,
  preguntas
) => {
  if (!tenderInfo || !postulaciones || postulaciones.length === 0) {
    toast.error("No hay información disponible para exportar.");
    return;
  }

  // ✅ Crear un nuevo libro de Excel
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Licitación y Postulaciones");

  // 🎨 **Estilos para encabezados**
  const headerStyle = {
    font: { bold: true, color: { argb: "FFFFFF" }, name: "Arial", size: 11 },
    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "4F81BD" } },
    alignment: { horizontal: "center", vertical: "middle" },
  };

  // 🎨 **Estilos para celdas normales**
  const cellStyle = {
    alignment: { horizontal: "center", vertical: "middle" },
    font: { name: "Arial", size: 11 },
  };

  // ✅ Agregar detalles de la licitación (manteniendo la primera tabla sin cambios)
  const details = [
    ["Detalles de la Licitación"],
    ["Título", tenderInfo.tender.titulo],
    ["Nº de Licitación", tenderInfo.tender.id_tender],
    ["Categoría", tenderInfo.tender.categoria],
    ["Empresa", tenderInfo.tender.company_name || "No especificado"],
    [
      "Creador",
      `${tenderInfo.tender.user_name} ${tenderInfo.tender.user_lastname}`,
    ],
    [
      "Ciudades",
      (() => {
        try {
          const ciudades = JSON.parse(tenderInfo.tender.ciudad);
          return Array.isArray(ciudades)
            ? ciudades.join(", ")
            : "No especificado";
        } catch (e) {
          return "No especificado";
        }
      })(),
    ],
    ["Última Actualización", tenderInfo.tender.created_at],
    ["Fecha Máx de Postulación", tenderInfo.tender.fecha_maxima_postulacion],
  ];

  details.forEach((row) => {
    const rowRef = worksheet.addRow(row);

    // **Columna A (Encabezados)**
    rowRef.getCell(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "4F81BD" }, // Azul claro solo para A
    };
    rowRef.getCell(1).font = {
      bold: true,
      name: "Arial",
      size: 11,
      color: { argb: "FFFFFF" },
    };
    rowRef.getCell(1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };

    // **Columna B (Valores)**
    rowRef.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
    rowRef.getCell(2).font = { name: "Arial", size: 11 };

    // Aplica bordes a ambas columnas
    rowRef.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // ✅ Agregar una fila vacía sin formato después de los detalles
  worksheet.addRow([]);

  // ✅ Crear la segunda tabla con los postulantes en filas y preguntas como columnas adicionales
  const headers = [
    "Postulación",
    "Nombre postulante",
    "Correo postulante",
    "Celular postulante",
    "Propuesta de los postulantes",
    "Documentos Adjuntos",
    ...preguntas.map((p) => p.question), // Agregar preguntas como encabezados
  ];

  const headerRow = worksheet.addRow(headers);

  // Aplicar estilos a los encabezados
  headerRow.eachCell((cell) => {
    cell.style = headerStyle;
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // ✅ Agregar filas de datos para cada postulante
  postulaciones.forEach((p) => {
    const postulacionRow = worksheet.addRow([
      p.id_application,
      `${p.user_postulante.nombre} ${p.user_postulante.apellido}`,
      p.user_postulante.correo,
      `+${p.user_postulante.codigo_pais} ${p.user_postulante.celular}`,
      p.detalles_oferta || "No especificado",
      p.archivos_adjuntos && p.archivos_adjuntos.length > 0
        ? p.archivos_adjuntos.map((a) => a.file_name).join(", ")
        : "Sin documentos",
      ...preguntas.map((pregunta) => {
        const respuesta = p.respuestas_preguntas_licitador[pregunta.question];
        if (respuesta && typeof respuesta === "object" && respuesta.file_name) {
          return respuesta.file_name;
        }
        return respuesta || "No respondida";
      }),
    ]);

    // Aplicar estilos a cada celda en la fila
    postulacionRow.eachCell((cell) => {
      cell.style = cellStyle;
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // ✅ Ajustar ancho de columnas automáticamente
  worksheet.columns.forEach((column) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const text = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, text.length);
    });
    column.width = maxLength + 5;
  });

  worksheet.views = [{ showGridLines: false }];

  // ✅ Agregar una fila vacía antes del pie de página
  worksheet.addRow([]);

  // ✅ Agregar pie de página con branding
  const footerRow = worksheet.addRow(["Creado por Procu"]);
  footerRow.getCell(1).font = {
    italic: true,
    color: { argb: "808080" },
    size: 10,
  };
  footerRow.getCell(1).alignment = { horizontal: "center" };

  // ✅ Fusionar celdas para centrar el texto
  worksheet.mergeCells(`A${footerRow.number}:B${footerRow.number}`);

  // ✅ Generar archivo y descargar
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `Licitacion_${tenderInfo.tender.id_tender}_${tenderInfo.tender.titulo}.xlsx`
  );
};
